import { IDropdownOption } from "@fluentui/react";

// Destination Type Enum
export enum DestinationType {
    sharepoint = 'sharepoint',
    blobContainer = 'blobContainer',
}

export const destinationOptions: IDropdownOption[] = [
            { key: DestinationType.sharepoint, text: 'Sharepoint' },
            { key: DestinationType.blobContainer, text: 'Azure Blob Container' },
        ];


// File Provision Config Interface
export interface IFileProvisionConfig {
    id: number;
    destinationType: string;
    rawQuery: string;
    
    // SharePoint-specific
    siteUrl?: string;
    driveId?: string;
    folderPath?: string;
    
    // Blob-specific
    containerName?: string;
    
    // General
    targetUri?: string;
    
    // Internal fields (not displayed in UI)
    authType?: string;
    credentialsReference?: string;
    
    frequencyCron?: string;
    isActive: boolean;
    lastRunAt?: Date | string | null;
    notes?: string;
}

// Helper function to get destination type badge color
export const getDestinationTypeColor = (type: string): string => {
    switch (type) {
        case DestinationType.sharepoint:
            return '#0078d4'; // Blue
        case DestinationType.blobContainer:
            return '#107c10'; // Green
        default:
            return '#605e5c'; // Gray
    }
};

